// extracted by mini-css-extract-plugin
module.exports = {"adPlaceholder":"DdjKqYde","layout":"gFyniMZQ","legacy":"X4MuF06r","main":"n2Bv29x_","fullWidth":"MRbYyEr_","noMargins":"Z57BPDiM","new":"iANI69rf","new_wide":"XpM_nEg7"};